import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs";
import { TransitService } from "src/app/front-user/services/e-booking/transit-request/transit-request.service";
import { User } from "src/app/front-user/shared/models/user.model";
import { BaseRequestService } from "src/app/front-user/shipyard-service/services/base-request.service";
import { AlertService } from "src/app/shared/components/alert/alert.service";
import { BaseRequest } from "src/app/shared/models/base-request.model";
import { FormMode, Languages, ServiceStatus, TransitRequestWFSteps } from "src/app/shared/models/enums.model";
import { ResponseObject } from "src/app/shared/models/response-object.model";
import { GlobalServices } from "src/app/shared/services/global.service";
import { WFHistoryService } from "src/app/shared/services/wfhistory.service";
import { ServicesRequestWorkflowHistory } from "src/app/front-user/services/e-booking/shared/models/services-request-workflow-history.model";
import { TransitRequestCustomDTO } from "src/app/shared/models/transit-request-custom-dto.model";
import { Router } from '@angular/router';
import { TransitRequestComponent } from "src/app/front-user/services/e-booking/transit-request/transit-request.component";
import { TransitIssueResolutionComponent } from "src/app/front-user/services/e-booking/transit-issue-resolution/transit-issue-resolution.component";
import { MarineConfirmCancelTransitComponent } from "../marine-confirm-cancel-transit/marine-confirm-cancel-transit.component";
@Component({
  selector: "app-refund-payment",
  templateUrl: "./refund-payment.component.html",
})
export class RefundPaymentComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepId: number = TransitRequestWFSteps.RefundPayment;
  refundPaymentForm: FormGroup;
  submitted = false;
  showRequest = false;
  isErrorMessage = false;
  lockTaskErrorMessage = false;
  loading = false;
  baseRequestId: string = "";
  requestStatus: number;
  baseRequestDTO: BaseRequest;
  displayedLang: string;
  currentUser: User = new User();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  @ViewChild('TransitIssueResolution', { static: false }) TransitIssueResolution: TransitIssueResolutionComponent;
  @ViewChild('MarineConfirmCancelTransitComponent', { static: false }) MarineConfirmCancelTransitComponent: MarineConfirmCancelTransitComponent;
  isLoaded: boolean = false;
  responseObj: ResponseObject = new ResponseObject();
  stepHistoryId: any;
  stepData: any;
  requestStatuses: number[];

  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private transitService: TransitService,
    private wfhistoryService: WFHistoryService,
    private router: Router
  ) {
    this.displayedLang =
      this.globalSrv.getLanguage() == Languages.Arabic ? "NameAR" : "NameEN";
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      // this.baseRequestId = "A1EABCF5-33FE-427C-A871-93ECEEF05F0F";
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.refundPaymentForm = this.formBuilder.group({
      ConfirmRefundPayment: [false, Validators.requiredTrue],
    });
  }

  get f() {
    return this.refundPaymentForm.controls;
  }

  getBaseRequest() {
    this.baseRequestService
      .getBaseRequest(this.baseRequestId)
      .subscribe((d) => {
        this.baseRequestDTO = d.Data;
        // this.requestStatus = this.baseRequestDTO.StatusId;
        this.requestStatuses = this.baseRequestDTO.RequestStatuses.map(s => s.StatusId);
        this.isLoaded = true;
        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) {
          this.getTransitRequestWFHistoryById();
          this.formMode = FormMode.Readonly;
          this.refundPaymentForm.disable();
        } else if (!this.requestStatuses.includes(ServiceStatus.Transit_PendingRefundPayment)) {
          this.getTransitRequestWFHistory();
          this.formMode = FormMode.Readonly;
          this.refundPaymentForm.disable();
        }
      });
  }

  getTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, this.stepId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitRequestWFHistoryCompleted(this.stepData);
        }
      }
    );
  }

  getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, this.stepId, this.stepHistoryId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }
    );
  }

  getTransitRequestWFHistoryCompleted(stepData: any) {
    if (!stepData) return;
    this.refundPaymentForm.patchValue({
      ConfirmRefundPayment: this.stepData.ConfirmRefundPayment
    });
    this.refundPaymentForm.disable();
  }

  onSubmit() {
    this.submitted = true;
    if (this.refundPaymentForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.StepId = this.stepId;
    this.transitRequestCustomObj.StepData = JSON.stringify(this.refundPaymentForm.getRawValue());
    this.transitRequestCustomObj.IsPaymentRefunded = this.refundPaymentForm.getRawValue().ConfirmRefundPayment;
    this.transitRequestCustomObj.CompletedBy = this.currentUser.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.DirectionId = this.MarineConfirmCancelTransitComponent?.TransitRequest?.feesRequest.feesDetailsForm.get('DirectionId')?.value;
    this.transitRequestCustomObj.IsAdmin = this.currentUser.IsAdmin;



    this.transitService.SubmitRefundPaymentDecision(this.transitRequestCustomObj)
      .subscribe((data: ResponseObject) => {
        if (data.Success) {
          this.globalSrv.isLoaderEnabled = false;
          this.refundPaymentForm.reset();
          this.loading = false;
          this.showRequest = true;
          this.isErrorMessage = false;
        } else if (data.ErrorMessages && data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
          this.lockTaskErrorMessage = true;
          this.showRequest = true;
          this.globalSrv.isLoaderEnabled = false;
        } else {
          this.globalSrv.isLoaderEnabled = false;
          this.showRequest = true;
          this.isErrorMessage = true;
          this.loading = false;
        }
      });
  }
}
